import { formatAmount, formatMinorUnitsValueToFullNumberWithDecimals } from './formatAmount'
import { Money } from './money.types'

export const formatMoney = ({ amount, currency }: Money, minorUnits: number, language = 'en-US') =>
  formatAmount({
    currencyCode: currency,
    value: formatMinorUnitsValueToFullNumberWithDecimals(amount, minorUnits),
    language
  })
